import magPlus from '../../../pics/icons/magPlus.PNG'
import magMinus from '../../../pics/icons/magMinus.PNG'
import OptionButton from '../OptionButton';

const TvTableSizeToggle = ({label, tableViewKey, currentSize, handlePvOptionChange}) => {
    return (
        <>
            <span>{label}</span>
            <OptionButton imgClassName={'magOptionsSmall'} src={magMinus} message={`Shrink ${label}`} onClickFunction={()=> handlePvOptionChange('tableView', tableViewKey, -1)}/>
            <OptionButton imgClassName={'magOptionsSmall'} src={magPlus} message={`Grow ${label}`} onClickFunction={()=> handlePvOptionChange('tableView', tableViewKey, 1)}/>
            <div>
                &nbsp;({currentSize}<span style={{fontSize: '8px'}}>x</span>) 
            </div>
        </>
    );
}

export default TvTableSizeToggle;